import { DotTypingLoader } from '../loaders/dotTypingLoader'

import { Container } from './style'

export function Button({ 
    icon, 
    isLoading,
    children, 
    ...rest 
}) {
    return(
        <Container
            isLoading={isLoading} 
            {...rest}
        >
            {
                isLoading 
                ? <DotTypingLoader />
                :
                <>
                    {icon}
                    {children}
                </>
            }
        </Container>
    )   
}
